<template>
  <div class="vipModal">
    <img
      class="closeIcon"
      src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220624/293cba04c858462be51c6f41f6fa9191.png"
      alt=""
      @click="close"
    />
    <div class="content">
      <div class="mainText">
        <div class="title">腾讯会议联合立吉答题<br />送您7天付费版权限</div>
        <div :class="btnActive ? 'btn' : 'btn disbale'" @click="getVip">
          {{ btnMsg }}
        </div>
        <div class="err-text" v-if="isError">{{ errText }}</div>
        <div class="desc" v-else>
          <p><span></span>立吉答题付费权限先到先得</p>
          <p><span></span>活动时间：{{ time }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import { getToken, verifyAuth, requestAuth } from "@/utils/common";
import api from "@/utils/api";

export default {
  props: ["time"],
  data() {
    return {
      btnMsg: "立即领取",
      btnActive: true,
      errText: "",
      isError: false
    };
  },
  methods: {
    close() {
      this.$emit("closeVipModal");
    },
    async getVip() {
      let loginStatus = await verifyAuth();
      if (loginStatus) {
        let param = {
          access_token: getToken()
        };
        questionOnly.post("/xcx/ques/v1/meeting/lead_vip", param).then(res => {
          this.btnActive = false;
          if (res.sta == 0) {
            this.btnActive = false;
            this.btnMsg = "领取成功";
            setTimeout(() => {
              this.$emit("closeVipModal");
            }, 2000);
          } else {
            this.isError = true;
            this.btnMsg = "领取失败";
            this.errText = res.msg;
          }
        });
      } else {
        localStorage.setItem("loginTip", 3);
        requestAuth("https://" + api.hostName + ".xiaoxiaodati.com/login");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px / 75 + rem;
}
.vipModal {
  position: relative;
  .closeIcon {
    width: rem(74);
    height: rem(74);
    float: right;
    top: rem(20);
    right: rem(90);
    position: relative;
  }
  .content {
    min-width: rem(750);
    width: rem(750);
    height: rem(561);
    background-repeat: no-repeat;
    background: url("https://cdn-xcx-qunsou.weiyoubot.cn/material/20220629/14db80b9e8c197a15cdef944a3757eb4.png ")
      no-repeat;
    object-fit: cover;
    background-size: 100% 100%;
    padding-top: rem(250);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    .mainText {
      text-align: center;
      width: rem(530);
      box-sizing: border-box;
      position: relative;

      .title {
        font-size: rem(32);
        line-height: rem(52);
        color: #000000;
      }
      .btn {
        border-radius: rem(20);
        height: rem(75);
        line-height: rem(75);
        text-align: center;
        font-size: rem(32);
        color: #ffffff;
        margin: rem(20) rem(30);
        background: linear-gradient(271.17deg, #0180ff 0.47%, #68cdff 100%);
        cursor: pointer;
        &.disbale {
          pointer-events: none;
          background: linear-gradient(
            271.17deg,
            rgba(1, 128, 255, 0.3) 0.47%,
            rgba(104, 205, 255, 0.3) 100%
          );
        }
      }
      .desc {
        width: rem(506);
        text-align: left;
        margin: 0 rem(30);
        font-size: rem(22);
        line-height: rem(33);
        color: #7b818f;
        position: relative;
        p {
          display: flex;
          align-items: center;
          span {
            width: rem(5);
            height: rem(5);
            border-radius: 50%;
            background: #7b818f;
            display: inline-block;
            margin-right: rem(10);
          }
        }
        p:first-child {
          margin-bottom: rem(5);
        }
      }
      .err-text {
        font-size: rem(28);
        line-height: rem(33);
        color: #006fff;
        margin-top: rem(30);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vipModal.vue